import { useTranslation } from '@klv/hooks/useTranslation';
import { useModal } from '@klv/context/modal';
import { generateClassName } from '@klv/shared/utils/functions';
import Buttons from '@klv/molecules/buttons';
import Icon from '@klv/atoms/icon';

import * as s from './styles/success.module.css';

import type { IDemoSuccess } from '../types';


const DemoSuccess = ({ colorVariant, templateName }: IDemoSuccess) => {
  const { t } = useTranslation();
  const modalStore = useModal();

  const buttonAction = (url: string) => {
    if (typeof window !== 'undefined') {
      const newUrl = new URL(url, window.location.origin);
      window.location.assign(newUrl.href);
    }
    modalStore.close();
  };

  const headline = t('organisms_forms_demo_success_headline');
  const message = t('organisms_forms_demo_success_headline');

  return (
    <div className={generateClassName([s.successGrid, 'grid'])}>
      <div className={s.successContent}>
        <div className={s.successContainer}>
          <Icon className={s.icon} iconName="BugMarkFilled" color="currentColor" />
          <h2 className={generateClassName([s.successHeadline, s[colorVariant], 'display3'])}>{headline}</h2>
          <div className={generateClassName([s.successMessage, s[colorVariant], 'p2'])}>
            {message}
          </div>
          {
            templateName === 'Default' && (
              <Buttons
                className={s.successButtons}
                variants={['primary', 'ghost']}
                buttonColor={colorVariant}
                buttons={[
                  { text: t('organisms_forms_demo_success_buttonOne') || '', action: () => {buttonAction('/features');} },
                  { text: t('organisms_forms_demo_success_buttonTwo') || '', action: () => {buttonAction('/marketing-resources');} },
                ]} />
            )}
        </div>
      </div>
      <div className={s.bottomTriangle} />
    </div>
  );
};

export default DemoSuccess;
